import React, {memo, ReactNode} from 'react';

import {gt} from 'app/utils/i18n';

import {BaseAvatar} from './BaseAvatar';
import {AvatarTooltipsProps, getTooltipContent} from './tooltips';

import {BasicTeamSerializedType} from 'sweet-types';

interface Props extends AvatarTooltipsProps {
  team: BasicTeamSerializedType;
  multiple?: boolean;
  link?: boolean;
  displayBlock?: boolean;
  className?: string;
  style?: any;
  small?: boolean;
}
export const TeamAvatar = memo<Props>(
  function UserAvatar({
    team,
    className = '',
    multiple,
    tooltipPlacement,
    tooltipTitle,
    style,
    displayBlock,
    link,
    small,
  }: Props) {
    const teamTitle = getTeamTitle(team);
    return (
      <BaseAvatar
        title={teamTitle}
        backgroundImage="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNTEyIj48cGF0aCBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9IjI1JSIgZD0iTTk2IDIyNGMzNS4zIDAgNjQtMjguNyA2NC02NHMtMjguNy02NC02NC02NC02NCAyOC43LTY0IDY0IDI4LjcgNjQgNjQgNjR6bTQ0OCAwYzM1LjMgMCA2NC0yOC43IDY0LTY0cy0yOC43LTY0LTY0LTY0LTY0IDI4LjctNjQgNjQgMjguNyA2NCA2NCA2NHptMzIgMzJoLTY0Yy0xNy42IDAtMzMuNSA3LjEtNDUuMSAxOC42IDQwLjMgMjIuMSA2OC45IDYyIDc1LjEgMTA5LjRoNjZjMTcuNyAwIDMyLTE0LjMgMzItMzJ2LTMyYzAtMzUuMy0yOC43LTY0LTY0LTY0em0tMjU2IDBjNjEuOSAwIDExMi01MC4xIDExMi0xMTJTMzgxLjkgMzIgMzIwIDMyIDIwOCA4Mi4xIDIwOCAxNDRzNTAuMSAxMTIgMTEyIDExMnptNzYuOCAzMmgtOC4zYy0yMC44IDEwLTQzLjkgMTYtNjguNSAxNnMtNDcuNi02LTY4LjUtMTZoLTguM0MxNzkuNiAyODggMTI4IDMzOS42IDEyOCA0MDMuMlY0MzJjMCAyNi41IDIxLjUgNDggNDggNDhoMjg4YzI2LjUgMCA0OC0yMS41IDQ4LTQ4di0yOC44YzAtNjMuNi01MS42LTExNS4yLTExNS4yLTExNS4yem0tMjIzLjctMTMuNEMxNjEuNSAyNjMuMSAxNDUuNiAyNTYgMTI4IDI1Nkg2NGMtMzUuMyAwLTY0IDI4LjctNjQgNjR2MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjUuOWM2LjMtNDcuNCAzNC45LTg3LjMgNzUuMi0xMDkuNHoiIGNsYXNzPSIiPjwvcGF0aD48L3N2Zz4="
        displayBlock={displayBlock}
        multiple={multiple}
        className={className}
        style={style}
        small={small}
        link={link === true ? team.html_url : undefined}
        tooltipPlacement={tooltipPlacement}
        tooltipContent={getTooltipContent(
          getTeamTooltipItemName(teamTitle),
          tooltipTitle
        )}
      />
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.team.name === nextProps.team.name &&
      prevProps.team.name === nextProps.team.name
    );
  }
);

export function getTeamTitle(team: BasicTeamSerializedType): string {
  return team.name;
}

export function getTeamTooltipItemName(name: string | ReactNode): ReactNode {
  return (
    <span>
      {name} <span className="font-italic">{gt('team')}</span>
    </span>
  );
}
